import { Grade } from "@mui/icons-material";
import { Divider, Grid, Paper, Typography } from "@mui/material";
import * as React from "react";
import PsychologyIcon from "@mui/icons-material/Psychology";

interface i_dashboardButton {
  title: string;
  value: string;
  marginRight: number;
}

const DashboardButton: React.FunctionComponent<i_dashboardButton> = (props) => {
  return (
    <Paper
      sx={{
        display: "flex",
        alignItems: "center",
        // justifyContent: "center",
        py: 2,
        mr: props.marginRight,
        flex: 1,
      }}
    >
      {/* <Grid item mr={2}>
        <Grade />
      </Grid> */}
      <Grid direction="column" item container>
        <Typography
          align="center"
          color="secondary"
          fontWeight="bold"
          sx={{
            fontSize: "20px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* <PsychologyIcon color="primary" /> */}
          {props.value}
        </Typography>
        <Divider
          sx={{
            mt: 1,
          }}
        >
          <Typography>{props.title}</Typography>
        </Divider>
      </Grid>
    </Paper>
  );
};

export default DashboardButton;
